import { rootComputed } from '@/store/common/helpers';
import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	dayCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let searcCuRslt = Number(state.searchParams.searchDate);
		let cuRsltLabel = searcCuRslt.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		let thisYear = moment().format('YYYY');
		let thisDt = moment().format('MM');
		let searchYear = searcCuRslt.toString();

		let carScn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001015')}`, //차량구분
			prop: 'carScnNm',
			align: 'left',
			width: '100px',
			sortable: false
		};
		// let plntCd = {
		// 	label: `${rootGetters['commonStore/getMessage_']('QWCC001540')}`, //생산공장
		// 	prop: 'plntNm',
		// 	align: 'left',
		// 	minWidth: '100px',
		// 	sortable: false
		// };
		let saleRegn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001019')}`, //판매지역
			prop: 'occuRegnNm',
			align: 'left',
			minWidth: '100px',
			sortable: false
		};
		// let saleNat = {
		// 	label: `${rootGetters['commonStore/getMessage_']('QWCC001542')}`, //국가
		// 	prop: 'saleNatNm',
		// 	align: 'left',
		// 	minWidth: '100px',
		// 	sortable: false
		// };

		cols.push(carScn);
		//cols.push(plntCd);
		cols.push(saleRegn);
		//cols.push(saleNat);

		// if (thisYear != searchYear) {
			for (let month = 1; month < 13; month++) {
				let pclProp = 'mm' + setLpad(month, 2, '0');
				let labelMom = setLpad(month, 2, '0');
				var newCol = {
					label: cuRsltLabel + labelMom + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
					prop: pclProp,
					minWidth: '100px',
					align: 'right',
					sortable: false,
					custom: true,
					labelClassName: searchYear + labelMom
				};
				cols.push(newCol);
			}
		// } else {
			// if (thisDt > 8) {
			// 	for (let month = 1; month < 13; month++) {
			// 		let pclProp = 'mm' + setLpad(month, 2, '0');
			// 		let labelMom = setLpad(month, 2, '0');
			// 		var newCol = {
			// 			label: cuRsltLabel + labelMom + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
			// 			prop: pclProp,
			// 			minWidth: '100px',
			// 			align: 'right',
			// 			sortable: false,
			// 			custom: true,
			// 			labelClassName: searchYear + labelMom
			// 		};
			// 		cols.push(newCol);
			// 	}
			// } else {
				// for (let month = 0; month < 12; month++) {
				// 	let pclSearchDate = moment().subtract(8, 'M').add(month, 'M').format('YYYYMM');
				// 	let pclYear = pclSearchDate.toString().substring(2, 4);
				// 	let pclMonth = pclSearchDate.toString().substring(4, 6);
				// 	let pclmonthm = month + 1;
				// 	let pclProp = 'mm' + setLpad(pclmonthm, 2, '0');
				// 	let labelMom = setLpad(pclmonthm, 2, '0');
				// 	var newCol = {
				// 		label:
				// 			pclYear +
				// 			`${rootGetters['commonStore/getMessage_']('QWCC001451')}` +
				// 			' ' +
				// 			pclMonth +
				// 			`${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
				// 		prop: pclProp,
				// 		minWidth: '100px',
				// 		align: 'right',
				// 		sortable: false,
				// 		custom: true,
				// 		labelClassName: searchYear + labelMom
				// 	};
				// 	cols.push(newCol);
				// }
			// }
		// }
		return cols;
	},
	monthlabel_: () => {
		let monthlabel = [];
		for (let i = 1; i < 13; i++) {
			let label = 'mm' + setLpad(i, 2, '0');
			monthlabel.push(label);
		}
		return monthlabel;
	}
};
